import React, { useContext, useState } from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../redux/store'
import { ShowCabinetContext, cabinetInterface } from './types'
import { hostName } from '../../requestMethods'
import { FaEdit } from 'react-icons/fa'
import { MdRemoveCircle } from 'react-icons/md'
import { useNavigate } from 'react-router'
import { DefaultDoctorInterface, DoctorInterface } from '../doctors/types'
import { InputElement } from '../../HtmlComponents/InputElement'
import { DefaultMoughataaInterface, moughataaInterface } from '../moughataa/types'
import { useTranslation } from 'react-i18next'
import { SelectElementCustom } from '../../HtmlComponents/SelectElementCustom'

const DataCabinet = () => {
  const { cabinets } = useSelector((state: State) => state.cabinets)
  const { doctors } = useSelector((state: State) => state.doctors)
  const { moughataas } = useSelector((state: State) => state.moughataas)
  const navigate = useNavigate()

  const { showDeleteModal, setShowDeleteModal, setSelectedCabinet } = useContext(ShowCabinetContext)

  const toggleDeleteModal = (cabinet: cabinetInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedCabinet(cabinet)
  }

  const [selectedMoughataa, setSelectedMoughataa] = useState<moughataaInterface>(DefaultMoughataaInterface)
  const [search, setSearch] = useState("")

  const filteredCabinets = cabinets
    .filter((cabinet: cabinetInterface) =>
      selectedMoughataa._id
        ? cabinet.moughataa?._id?.includes(selectedMoughataa._id)
        : true
    )
    .filter((cabinet: cabinetInterface) => cabinet.name.toUpperCase().includes(search.toUpperCase()))

  const { t } = useTranslation()

  return (
    <>
      {/* Filter Section */}
      <section className='flex flex-col md:flex-row justify-between items-center gap-2'>
        <SelectElementCustom
          name='Moughataa'
          valueType="object"
          options={moughataas.map((m: moughataaInterface) => ({ _id: m._id, name: m.name }))}
          defaultOption={<option data-element={JSON.stringify({})}>Tous</option>}
          value={selectedMoughataa}
          setValue={setSelectedMoughataa}
        />

        <div className='font-bold text-2xl'>
          {t("Total")}: <span className='text-main'>{filteredCabinets.length}</span>
        </div>
      </section>

      {/* Search Input */}
      <div className='mt-3 grid md:grid-cols-3'>
        <InputElement
          name='Chercher un cabinet'
          placeholder='Chercher un cabinet par son nom'
          value={search}
          setValue={setSearch}
        />
      </div>

      {/* Cabinet Cards */}
      <div className='grid md:grid-cols-3 gap-4 mt-4'>
        {filteredCabinets.map((cabinet: cabinetInterface) => {
          const owner: DoctorInterface =
            doctors.find((doc:DoctorInterface) => doc.cabinet?._id === cabinet._id && doc.isOwner) || DefaultDoctorInterface

          return (
            <section
              key={cabinet._id}
              className='bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition duration-300'
            >
              {cabinet.logo && (
                <div className='mb-3'>
                  <img
                    className='w-full h-56 object-cover rounded-md'
                    src={`${hostName}imgs/cabinets/${cabinet.logo}`}
                    alt={cabinet.name}
                  />
                </div>
              )}

              <div className='space-y-1 text-sm'>
                <p className='flex justify-between'><b>Nom:</b> <span>{cabinet.name}</span></p>
                <p className='flex justify-between'><b>Propriétaire:</b> <span>{owner.fullName}</span></p>
                <p className='flex justify-between'><b>Téléphone:</b> <span>{cabinet.phone}</span></p>
                <p className='flex justify-between'><b>Adresse:</b> <span>{cabinet.address}</span></p>
                <p className='flex justify-between'><b>Moughataa:</b> <span>{cabinet?.moughataa?.name}</span></p>
                <p className='flex justify-between'><b>Autorisation:</b> <span>{cabinet.authorization}</span></p>
                <p className='flex justify-between'><b>Type:</b> <span>{cabinet.type}</span></p>
              </div>

              {/* Action Buttons */}
              <div className='flex justify-center gap-6 mt-4'>
                <FaEdit
                  title="Modifier"
                  className='text-second hover:text-second-hover text-2xl cursor-pointer transition transform hover:scale-110'
                  onClick={() => navigate(`update/${cabinet._id}`, { state: { cabinet } })}
                />
                <MdRemoveCircle
                  title="Supprimer"
                  className='text-red hover:text-red-hover text-2xl cursor-pointer transition transform hover:scale-110'
                  onClick={() => toggleDeleteModal(cabinet)}
                />
              </div>
            </section>
          )
        })}
      </div>
    </>
  )
}

export default DataCabinet
